import React from 'react';
import { AssetShape } from './shapes';

const AssetLinkedEntitiesCellItem = ({ entity }) => {
  return <div>{entity.clientAssetId}</div>;
};

AssetLinkedEntitiesCellItem.propTypes = {
  /**
   * The issue entity we need to render.
   */
  entity: AssetShape.isRequired
};

export default AssetLinkedEntitiesCellItem;
